import {AfterViewChecked, ChangeDetectorRef, Component, DoCheck, NgZone, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SearchPipe} from '../pipes/search-pipe.pipe';
import {Subscription} from 'rxjs';
import {environment} from '../../../environments/environment';
import {GetSetDataService} from '../../services/get-set-data.service';
import {NgIf} from '@angular/common';
import {MainFilterComponent} from '../main-filter/main-filter.component';
import {LoginUserComponent} from '../login-user/login-user.component';
import {FavoriteReportsComponent} from '../favorite-reports/favorite-reports.component';
import {SingleReportSmallComponent} from '../single-report-small/single-report-small.component';
import {PostViewComponent} from '../post-view/post-view.component';
import {LoaderComponent} from '../loader/loader.component';

@Component({
  selector: 'app-center-view',
  templateUrl: './center-view.component.html',
  styleUrls: ['./center-view.component.scss'],
  imports: [
    NgIf,
    MainFilterComponent,
    LoginUserComponent,
    FavoriteReportsComponent,
    SingleReportSmallComponent,
    PostViewComponent,
    LoaderComponent
  ],
  providers: [SearchPipe]
})
export class CenterViewComponent implements OnInit, OnDestroy, AfterViewChecked {

  public allData: any;
  public allCharts: any;
  public powerBiData: any;
  public favoriteReportsData: any;

  private subscriptionSearch?: Subscription;
  public singlePostData: any = [];
  public showPostComponent = false;
  public activeSortFilter = '';
  public activeReverseArray = true;
  public showSortView = true;
  public showFavoriteView = true;

  public loginURL = environment.LOGIN_URL;

  public showFavoriteIcon = true;

  public allReportsCounter?: number;

  public showAllData: boolean = true;

  constructor(private route: ActivatedRoute,
              private getSetData: GetSetDataService,
              private searchPipe: SearchPipe, private cdRef: ChangeDetectorRef) {
  }

  async ngOnInit() {


    this.route.params.subscribe(async (data): Promise<any> => {

      // Get favorite reports.
      this.favoriteReportsData = await this.getSetData.getFavoriteReports();

      if (!this.favoriteReportsData) {
        this.showFavoriteIcon = false;
      }


      if (data['post-name']) {
        this.showPostComponent = false;
        this.singlePostData = await this.getSetData.getSingleBlogPosts(data['post-name']);
        this.showPostComponent = true;
        return false;
      }

      if (data['name']) {
        const categoryData: any = await this.getSetData.getPostsByCategory(data['name']);
        this.allData = categoryData['results'];
        this.powerBiData = categoryData['top_content'];
        this.allCharts = categoryData['charts'];
      } else {
        this.allData = await this.getSetData.getAllPosts();
      }

      this.allReportsCounter = this.allData.length;
    });

    this.subscriptionSearch = this.getSetData.EmitterSearch.subscribe((data) => {
      const results = this.searchPipe.transform(this.allData, data);

      // Updates the search counter and shows in the application.
      this.allReportsCounter = results?.length;

      this.showSortView = results?.length !== 0;

      if (this.favoriteReportsData) {
        const resultsFavorites = this.searchPipe.transform(this.favoriteReportsData.data, data);
        this.showFavoriteView = resultsFavorites.length !== 0;
      }
    });
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  public fetchMainFilter(filter: any) {
    if (filter === 'favorites') {
      this.showAllData = false;
    } else {
      this.showAllData = true;
      this.activeSortFilter = filter;
    }

    console.log(this.activeSortFilter);
  }

  public fetchMainFilterReverse(filter: any) {
    this.activeReverseArray = filter;
  }

  ngOnDestroy() {
    if (this.subscriptionSearch) {
      this.subscriptionSearch.unsubscribe();
    }
  }
}
